import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, FileWarning, HelpCircle, Clock, Search } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: '"Alguien mandó las fotos por WhatsApp y después las borró. No se respaldaron a tiempo."',
    author: 'Constructor'
  }, {
    text: '"Se me perdió el celular y perdí muchísima información."',
    author: 'Subcontratista'
  }, {
    text: '"Es una lata andar pasando foto por foto y cuadrar en el Word."',
    author: 'Constructor'
  }, {
    text: '"El mandante pide explicación y nadie sabe qué se decidió."',
    author: 'Administrador'
  }, {
    text: '"Armar el informe toma 2 horas. Mínimo."',
    author: 'Administrador'
  }];
  return <section id="problema" className="py-12 sm:py-16 bg-white" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-269">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-270">
            <div className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-271">
              El problema
            </div>

            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-272">
              Tu obra ya está documentada. Solo se pierde.
            </h2>

            <div className="space-y-4 mb-8" data-id="element-273">
              {problems.map((problem, index) => {
              return <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-274">
                    <p className="text-gray-800 font-medium mb-1.5" data-id="element-275">
                      {problem.text}
                    </p>
                    <p className="text-xs text-gray-500 font-medium" data-id="element-276">
                      — {problem.author}
                    </p>
                  </motion.div>;
            })}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="inline-block px-5 py-3 bg-blue-50 border-2 border-blue-200 rounded-xl" data-id="element-277">
              <p className="text-sm font-bold text-blue-900" data-id="element-278">
                Un informe bien hecho te apura hasta los pagos. Sin informe,
                esperas.
              </p>
            </motion.div>
          </motion.div>

          {/* Right column - Chaos illustration */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-279">
            <div className="relative bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl p-8 border border-gray-200 shadow-lg overflow-hidden" data-id="element-280">
              {/* Chaotic photos */}
              <div className="relative h-[400px]" data-id="element-281">
                {/* Scattered photo placeholders */}
                <div className="absolute top-4 left-4 w-32 h-32 bg-gray-300 rounded-lg shadow-md transform -rotate-12 opacity-80" data-id="element-282" />
                <div className="absolute top-12 right-8 w-28 h-28 bg-gray-300 rounded-lg shadow-md transform rotate-6 opacity-70" data-id="element-283" />
                <div className="absolute bottom-20 left-12 w-36 h-36 bg-gray-300 rounded-lg shadow-md transform rotate-12 opacity-75" data-id="element-284" />
                <div className="absolute bottom-8 right-4 w-32 h-32 bg-gray-300 rounded-lg shadow-md transform -rotate-6 opacity-80" data-id="element-285" />
                <div className="absolute top-32 left-1/2 -translate-x-1/2 w-28 h-28 bg-gray-300 rounded-lg shadow-md transform rotate-3 opacity-65" data-id="element-286" />

                {/* Chat bubbles overlay */}
                <div className="absolute top-1/4 left-1/4 bg-white rounded-2xl rounded-bl-none px-4 py-2 shadow-lg max-w-[180px]" data-id="element-287">
                  <p className="text-xs text-gray-600" data-id="element-288">
                    ¿Alguien tiene la foto de la losa del martes?
                  </p>
                </div>

                <div className="absolute bottom-1/3 right-1/4 bg-blue-600 text-white rounded-2xl rounded-br-none px-4 py-2 shadow-lg max-w-[160px]" data-id="element-289">
                  <p className="text-xs" data-id="element-290">Creo que la mandó Juan...</p>
                </div>

                <div className="absolute top-1/2 left-1/3 bg-white rounded-2xl rounded-bl-none px-4 py-2 shadow-lg max-w-[140px]" data-id="element-291">
                  <p className="text-xs text-gray-600" data-id="element-292">¿Cuál Juan? 😅</p>
                </div>

                {/* Chaos indicators */}
                <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-293">
                  847 mensajes
                </div>
              </div>

              {/* Quote at bottom */}
              <div className="mt-6 pt-6 border-t border-gray-300" data-id="element-294">
                <p className="text-sm text-gray-600 italic text-center" data-id="element-295">
                  "¿Dónde está la foto de la losa del martes?"
                </p>
              </div>
            </div>

            {/* Decorative blur */}
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-red-200/30 rounded-full blur-3xl -z-10" data-id="element-296" />
          </motion.div>
        </div>
      </div>
    </section>;
}